/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { PopupService } from '../../../core/services/popup.service';

/**
 * @export
 * @class LocoStatusContainerDataComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-loco-status-container-data',
  templateUrl: './loco-status-container-data.component.html',
  styleUrls: ['./loco-status-container-data.component.scss']
})

export class LocoStatusContainerDataComponent implements OnInit, OnChanges {

  @Input() locoStatusArr: Array<LocoDetail>;
  @Input() searchLocomotiveText: string;
  @Output() locoSelectEvent = new EventEmitter();
  @Output() doubleEnterEventEmiiter = new EventEmitter();
  locoStatusDataArr: Array<LocoDetail>;
  configData: any;
  @Output() onLocoSelect: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() searchEventEmit: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() removeLocoEventEmit: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() 
  updateDataStoreEventEmit = new EventEmitter();
  MAX_ROWS = 20;
  popUpServiceSubscription: any;

  /**
   * Creates an instance of LocoStatusContainerDataComponent.
   * @memberOf LocoStatusContainerDataComponent
   */
  constructor(private configService: ConfigService,
    private appUtilityService: AppUtilityService,
    private popupService: PopupService) {
    this.configData = configService.getConfigData();
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });
  }

  /**
   * Invoked when add new row button triggred.
   *
   * @param {*} data
   * @memberof LocoStatusContainerDataComponent
   */
  checkSuccessOperation(data: any) {
    if (data && data.operation === 'addNewLocoRowOpr') {
      if (this.locoStatusArr.length < this.MAX_ROWS) {
        this.locoStatusArr.push({});
        this.locoStatusDataArr = this.locoStatusArr;
        setTimeout(() => {
          const searchTextId = document.getElementById('locoStatusSearchTextBox' + (this.locoStatusArr.length - 1));
          if (searchTextId && searchTextId !== null) {
            searchTextId.focus();
          }
        }, 200);
        this.updateDataStoreEvent();
      }
      else
      {
        this.doubleEnterEvent();
      }
    }
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusContainerDataComponent
   */
  ngOnInit() {
    this.locoStatusDataArr = this.locoStatusArr;
  }

  /**
   * Filter data in container on the basis of search text from filter.
   * @memberOf LocoStatusContainerDataComponent
   */
  ngOnChanges() {
    this.locoStatusDataArr = this.locoStatusArr;
    if (this.searchLocomotiveText) {
      const searchText = this.appUtilityService.UIformatLocomotiveId(this.searchLocomotiveText);
      this.locoStatusDataArr = _.filter(this.locoStatusArr, function (locoStatus) {
        return (locoStatus.searcheLocomotiveIdentifier === searchText);
      });
    }
  }

  /**
   * Invoked when make selection of loco.
   * @memberOf LocoStatusContainerDataComponent
   */
  locoSelectionEvent() {
    this.locoSelectEvent.emit();
  }

  /**
   * Remove loco status row.
   * @param {any} index
   * @memberOf LocoStatusContainerDataComponent
   */
  removeLocoStatusRow(index) {
    if (index !== -1) {
      if (this.searchLocomotiveText) {
        const locoStatus = this.locoStatusDataArr[index];
        if (locoStatus) {
          const mainIndex = this.locoStatusArr.indexOf(locoStatus);
          if (mainIndex !== -1) {
            this.locoStatusArr.splice(mainIndex, 1);
          }
        }
        const searchText = this.appUtilityService.UIformatLocomotiveId(this.searchLocomotiveText);
        this.locoStatusDataArr = _.filter(this.locoStatusArr, function (lStatus) {
          return (lStatus.searcheLocomotiveIdentifier === searchText);
        });
      } else {
        this.locoStatusArr.splice(index, 1);
        this.locoStatusDataArr = this.locoStatusArr;
      }
    }
    if (this.locoStatusArr && this.locoStatusArr.length === 0) {
      this.locoStatusArr.push({});
    }
    this.removeLocoEventEmit.emit(index);
  }

  /**
   * emits an event for double enter click.
   * @memberOf LocoStatusContainerDataComponent
   */
  doubleEnterEvent() {
    this.doubleEnterEventEmiiter.emit(this.locoStatusArr);
  }

  /**
 * This method invoked when right click on locomotive icon
 * for displaying locomotive information in context menu.
 * @param {any} event
 * @param {LocoDetail} loco
 * @returns
 * @memberOf LocoStatusContainerDataComponent
 */
  public showLocoContextMenu(loco: LocoDetail) {
    this.onLocoSelect.emit(loco);
  }

  /**
   * emits an event for invidual loco status search triggered.
   * @param {any} event
   * @memberOf LocoStatusContainerDataComponent
   */
  searchClickEvent(event) {
    this.searchEventEmit.emit(event);
  }

  /**
   * emits an event when clear loco status.
   * @param {any} event
   * @memberOf LocoStatusContainerDataComponent
   */
  removeLocoEvent(event) {
    if (event && this.locoStatusArr) {
      this.locoStatusArr = this.locoStatusArr.map((locoStatus) => {
        if (event.locomotiveIdentifier) {
          const locoId = this.appUtilityService.formatLocomotiveId(event.locomotiveIdentifier).replace(/\s/g, '');
          if (locoStatus.locomotiveIdentifier === locoId) {
            locoStatus = event;
          }
        }
        return locoStatus;
      });
      this.removeLocoEventEmit.emit(event.index);
    }
  }

  /**
 * Invoked when click on Backspace/Delete in search box in terminal handling.
 * @param {any} event
 * @memberOf LocoStatusContainerDataRowComponent
 */
  @HostListener('window:keydown', ['$event']) defaultTabFunctionality(event) {
    if (event && event.key === 'Tab' && !event.shiftKey && this.locoStatusArr) {
      for (let i = 0; i < this.locoStatusArr.length; i++) {
        if (this.locoStatusArr[i].searcheLocomotiveIdentifier) {
          this.locoStatusArr[i].searcheLocomotiveIdentifier =
            this.appUtilityService.UIformatLocomotiveId(this.locoStatusArr[i].searcheLocomotiveIdentifier);
        }
      }
      const searchTextBox = document.activeElement;
      if (this.locoStatusArr.length < this.MAX_ROWS &&
        searchTextBox && (searchTextBox.id === 'locoStatusSearchTextBox' + (this.locoStatusArr.length - 1))) {
        this.locoStatusArr.push({});
      }
      this.locoStatusDataArr = this.locoStatusArr;
      this.updateDataStoreEvent();
    }
  }

  /**
   * emits an event for update data store.
   * @memberOf LocoStatusContainerDataComponent
   */
  updateDataStoreEvent() {
    this.updateDataStoreEventEmit.emit();
  }

  /**
   * invoked when single enter click and update the UI accordingly.
   * @memberOf LocoStatusContainerDataComponent
   */
  singleEnterEvent() {
    if (this.locoStatusArr) {
      for (let i = 0; i < this.locoStatusArr.length; i++) {
        if (this.locoStatusArr[i].searcheLocomotiveIdentifier) {
          this.locoStatusArr[i].searcheLocomotiveIdentifier =
            this.appUtilityService.UIformatLocomotiveId(this.locoStatusArr[i].searcheLocomotiveIdentifier);
        }
      }
      const searchTextBox = document.activeElement;
      if (this.locoStatusArr.length < this.MAX_ROWS) {
        this.locoStatusArr.push({});
        this.locoStatusDataArr = this.locoStatusArr;
        setTimeout(() => {
          const searchTextId = document.getElementById('locoStatusSearchTextBox' + (this.locoStatusArr.length - 1));
          if (searchTextId && searchTextId !== null) {
            searchTextId.focus();
          }
        }, 200);
        this.updateDataStoreEvent();
      }
      else
      {
        this.doubleEnterEvent();
      }
    }
  }
}
